import moment, { type Moment } from 'moment';

type EntryTime = string | number | undefined;

export const getVisitorEntryTime = (entryTimes: EntryTime[]) => {
  let validEntryTimes: EntryTime[] | Moment[] = entryTimes.filter(
    (time) => time !== undefined && time !== ''
  );

  if (validEntryTimes.length === 0) {
    return '未進場';
  }

  validEntryTimes = validEntryTimes.map((time) => moment(time));

  const entryTime = moment.min(validEntryTimes).format('YYYY-MM-DD HH:mm:ss');

  return entryTime === 'Invalid date' ? '未進場' : entryTime;
};
